import "./navigation";
import "./togglize";
import "./site-banner";
import "SLICK/slick.js";
import "MFP/jquery.magnific-popup.js";

(function ($) {
  $(document).ready(function () {
    $("#primary-nav-toggle").on("click", function slideMenu(e) {
      // console.log("burger click");
      let $this = $(this);
      let expanded = $this.attr("aria-expanded") == "true" || false;
      $this.attr("aria-expanded", !expanded);
      $this.siblings(".menu-primary-menu-container").toggleClass("open");
      $this.siblings(".menu-left-side-main-menu-container").toggleClass("open");
      $this.siblings(".menu-right-side-main-menu-container").toggleClass("open");
    });

    let $mainNavTopParentLinks = $("#primary-menu > .menu-item-has-children");
    let $mainNavParentLinks = $("#primary-menu .menu-item-has-children");
    $mainNavTopParentLinks.each(function setupHoverAction(index, item) {
      let $item = $(item);
      let timer = {};
      $item.on("mouseenter", function showSub(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          let $subMenu = $(this).children(".sub-menu");
          $subMenu.css({
            opacity: 1,
            visibility: "visible"
          });
          // reveal any opened submenus to retain their state
          $subMenu.find(".sub-menu.open").addClass("show");
          // still hovering, cancel closing of this menu
          clearTimeout(timer);
        }
      });
      $item.on("mouseleave", function maybeHideSubmenu(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          timer = setTimeout(() => {
            let $subMenu = $(this).children(".sub-menu");
            $subMenu = $(this).children(".sub-menu").first();
            // hide any open nested sub menus but don't close them, this retains their open state when hovering again
            $subMenu.find(".sub-menu.open").removeClass("show");
            // set opacity 0 to allow animate fading in.
            $subMenu.css({
              opacity: 0,
              visibility: "hidden"
            });
          }, 300);
        }
      });
    });

    $mainNavTopParentLinks.on("blur", "button", function () {
      console.log("blur");
      let $button = $(this);
      let expanded = $button.attr("aria-expanded") == "true" || false;
      if (expanded) {
        $button.attr("aria-expanded", false);
        let $subMenu = $(this).siblings(".sub-menu").first();
        $subMenu.stop(true, false, true).slideToggle(300);
      }
    });

    $mainNavTopParentLinks.on("keyup", function (e) {
      if (window.matchMedia("(min-width: 981px)").matches) {
        let spaceBar = 32;
        let enter = 13;
        if (e.keyCode == spaceBar || e.keyCode == enter) {
          let $button = $(this).children("button").first();
          let expanded = $button.attr("aria-expanded") == "true" || false;
          $button.attr("aria-expanded", !expanded);
          let $subMenu = $(this).children(".sub-menu").first();
          $subMenu.stop(true, false, true).slideToggle(300);
        }
      }
    });

    // $nestedSubMenuButtons = $("#primary-menu .sub-menu .menu-item-has-children button")

    // $nestedSubMenuButtons.on("keyup", function (e) {
    //   e.stopPropagation()
    // })

    // $nestedSubMenuButtons.on("click", function (e) {
    //   e.stopPropagation()
    //   if (window.matchMedia("(min-width: 981px)").matches) {
    //     $(this).parents(".menu-item-has-children").children(".sub-menu").first().toggleClass(["open", "show"])
    //   }
    // })

    $(".featured-fp-card").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      // autoplay: true,
      // autoplaySpeed: 3000,
      infinite: true,
      rows: 0,
      lazyLoad: "ondemand",
      arrows: true,
      dots: false,
      // centerMode: true,
      // centerPadding: "90px",
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            // autoplay: true,
            // autoplaySpeed: 3000,
            infinite: true,
            rows: 0,
            lazyLoad: "ondemand",
            arrows: false,
            dots: true
          }
        }
      ]
    });
    $(".slick-next").append("<i class='arrow right'></i>");
    $(".slick-prev").append("<i class='arrow left'></i>");

    // Magnific popup for floor plans
    $(".sump-lightbox-image").magnificPopup({
      type: "image",
      image: {
        markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + "</div>" + "</div>" // Popup HTML markup. `.mfp-img` di
      },
      verticalFit: true // Fits image in area vertically
    });

    $(".gallery-popup").each(function (e) {
      // the containers for all your galleries
      $(this).magnificPopup({
        delegate: "a", // the selector for gallery item
        type: "image",
        gallery: {
          enabled: true
        }
      });
    });

    $(".video-control-button").on("click", function (e) {
      let $this = $(this);
      let label = $this.attr("aria-label");
      if (label === "play") {
        $this.attr("aria-label", "pause");
        $this.parent().siblings("video").trigger("play");
      } else {
        $this.attr("aria-label", "play");
        $this.parent().siblings("video").trigger("pause");
      }
      console.log("video: ", $this.parent().siblings("video"));
    });
    function reduceAllMotion() {
      console.log("reducing motion...");
      $("video").prop("autoplay", false).siblings(".video-control-button-container").find(".video-control-button").attr("aria-label", "play");
    }

    /**
     * Flag Prefers Reduced Motion
     */
    const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
      reduceAllMotion();
    }
  });
})(jQuery);
